import { Component, Input } from '@angular/core';
import { UtilityService } from 'src/app/core/services/utility.service';

@Component({
    selector: 'app-changed',
    templateUrl: './changed.component.html',
    styleUrls: ['../drb-diff.component.css']
})
export class ChangedComponent {
  @Input() public item;

  constructor(public utility: UtilityService) {}
}
